export const FILE_VIRUS_SCAN_STATUS = {
  INFECTED: 'INFECTED'
};
export const MAX_FILE_PREVIEW_SIZE_MB = 150 * 1000000;
export const MAX_ALLOWED_FILE_UPLOAD_SIZE_BYTES = 650 * 1000000;
